import { render, staticRenderFns } from "./setPopularity.vue?vue&type=template&id=2195fe16&scoped=true&"
import script from "./setPopularity.vue?vue&type=script&lang=js&"
export * from "./setPopularity.vue?vue&type=script&lang=js&"
import style0 from "./setPopularity.vue?vue&type=style&index=0&id=2195fe16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195fe16",
  null
  
)

export default component.exports